export default __webpack_public_path__ + "static/media/chevron_left.1afee069.svg";